// Router import
import { BrowserRouter } from 'react-router-dom';
import { PageRouter } from './route/PageRouter';
import { ScrollToTop } from './route/ScrollToTop';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <main>
          <PageRouter></PageRouter>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
